import { User } from 'oidc-client';
import React, { useContext, useEffect, useState } from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import { getUserInfo, renewAccessToken } from '../services/UserService';
import { store } from '../store';

const SilentRenew = () => {
    const globalState = useContext(store);
    const { dispatch } = globalState;

    useEffect(() => {
        renewAccessToken()
            .then(() => getUserInfo())
            .then((u: User | null) => {
                return u && u.profile.role_extended && u.profile.role_extended.includes("BureauPortal:plan_carrier")
                    ? dispatch({ type: "set admin status" })
                    : Promise.reject(new Error('User is not authorized Plan Carrier'));
            })
            .catch(() =>
                <Redirect to="/" />)
    }, [])

    return (
        <React.Fragment>
        </React.Fragment>
    )
}


export default SilentRenew